var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"mb-0 compeattext frontendblue--text"},[_c('b',{staticClass:"compeatbuttons--text"},[_vm._v("COMPEAT FOR")]),_c('b',{staticClass:"black--text ml-2"},[_vm._v(_vm._s(_vm.currentWord))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }